/**
 * @deprecated tag:v6.8.0 - `translation.init.ts` will be removed to use automatic language loading with language layer support
 */
import deCmsExtensionsSnippets from '../snippet/de.json';
import enCmsExtensionsSnippets from '../snippet/en.json';

Shopware.Locale.extend('de-DE', deCmsExtensionsSnippets);
Shopware.Locale.extend('en-GB', enCmsExtensionsSnippets);
